export default function getResource(label, vars = []) {
    const resources = {
        item: 'ARTICLE',
        items: 'articles',
        qty: 'QTÉ',
        basketSubtotal: 'Sous-total du panier',
        subTotal: 'Sous-total',
        continue: 'Continuer à magasiner',
        seeSamples: 'Voir les échantillons, récompenses et promotions dans le',
        basket: 'panier',
        standardTitle: 'Ajouté pour l’expédition',
        sddTitle: 'Ajouté pour la livraison le jour même',
        nddTitle: 'Ajouté pour la livraison rapide',
        reserveTitle: `Ajouté pour le ramassage à ${vars[0]}`,
        autoReplenishTitle: 'Ajouté pour le réapprovisionnement automatique',
        proceedToBasket: 'Passer au panier',
        viewInBasket: 'Voir dans le panier',
        viewAndCheckout: 'Voir le panier et passer à la caisse',
        viewAndReserve: 'Voir le panier et réserver',
        testSeeDetails: 'Voir les détails',
        mostCommon: 'le plus courant',
        deliverEvery: 'Livrer chaque',
        weeksShort: 'semaines',
        monthsShort: 'mois',
        months: 'mois',
        weeks: 'semaines',
        urgencyMessage: 'IL N’EN RESTE QUE QUELQUES-UNS : PASSEZ BIENTÔT À LA CAISSE',
        viewBasket: 'Voir le panier',
        limitedStock: 'Quantités limitées',
        inStock: 'En stock',
        at: 'à',
        for: 'pour',
        checkout: 'Passer à la caisse',
        seeSamplesNote: '*You can see samples, rewards & promotions in basket',
        freeShippingAdd: 'Add',
        freeShippingFor: 'for',
        fastFreeShipping: 'FAST FREE',
        freeShippingShippingOr: 'Shipping or',
        freeShippingOr: 'or',
        freeShippingSignIn: 'Sign In',
        freeShippingNoMinSpend: 'for FREE Shipping with no min spend',
        freeShippingOnAllOrders: 'for FREE Shipping on all orders',
        freeShippingThresholdMet: 'You\'re getting',
        fastFreeShippingFull: 'FAST FREE Shipping',
        freeShippingBeautyInsiderNoMinSpend: 'with no min spend because you\'re a Beauty insider.',
        freeShippingBeautyInsiderOnAllOrders: 'on all orders because you\'re a Beauty insider.',
        freeShippingProgressAriaLabel: `Free shipping progress: ${vars[0]}% toward ${vars[1]}`
    };

    return resources[label];
}
